import React, { useEffect, useRef, useState } from "react";
import photographer from "./images/photographer.svg";
import popup from "./images/popup-bg.png";
import "./styles/style.css";
import Telemetry from "../../utils/rudderstackAnalytics";

const getCsrfToken = (): string => {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  return meta?.content || "";
};

const ReferralForm = ({ activeForm }: { activeForm: string }) => {
  const formAction = activeForm === "ph"
    ? "/submit-refer-photographer"
    : "/submit-refer-organization";

  return (
    <form
      action={formAction}
      method="post"
      key={activeForm}
      onSubmit={() => {
        Telemetry.track(
          "internal-referrals:org-gallery-sell-your-photos-referral-submitted"
        );
      }}
    >
      <input type="hidden" name="authenticity_token" value={getCsrfToken()} />
      <input type="hidden" name="page_url" value={window.location.href} />
      <input type="hidden" name="redirect_path" value={window.location.pathname} />
      <div style={{ marginBottom: "15px" }}>
        <label htmlFor="sell-photos-email" style={{ fontWeight: "bold" }}>
          Email<span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="email"
          id="sell-photos-email"
          name="email"
          required
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "45px",
            fontSize: "14px",
            boxSizing: "border-box"
          }}
        />
      </div>
      <button
        type="submit"
        className="geo-btn geo-btn--primary"
        style={{
          width: "150px",
          display: "block",
          margin: "auto",
          marginBottom: "40px",
          padding: "12px",
          backgroundColor: "#259FA5",
          color: "#fff",
          border: "none",
          borderRadius: "45px",
          fontSize: "16px",
          cursor: "pointer"
        }}
      >
        Submit
      </button>
    </form>
  );
};

const SellYourPhotos = ({
  handleCloseClick
}: {
  handleCloseClick: Function;
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [activeForm, setActiveForm] = useState("ph");

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        handleCloseClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleCloseClick]);

  return (
    <div>
      <div
        id="modal-dialog"
        className="modal fade in geo-modal geo-modal--small geo-modal--warning geo-modal--show
        geo-modal--scroll"
        role="dialog"
      >
        <div
          className="modal-dialog filter-dialog-content geo-privacy-body geo-privacy-modal invite-modal"
          ref={popupRef}
        >
          <div
            className="modal-content"
            style={{
              backgroundImage: `url(${popup})`,
              backgroundPositionY: "bottom",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              minHeight: `448px`
            }}
          >
            <div className="modal-header">
              &nbsp;
              <button className="close" onClick={() => handleCloseClick()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="geo-modal__header geo-modal--warning-bg">
              <img
                className="geo-modal__warn-icon"
                src={photographer}
                alt="photographer-icon"
                style={{ width: 180 }}
              />
              <h4>I am a</h4>
              <div className="sell-your-photos-btn-cotainer">
                <button
                  className={`geo-btn ${
                    activeForm == "ph" ? "active-btn" : ""
                  }`}
                  onClick={() => {
                    Telemetry.track(
                      "internal-referrals:org-gallery-ph-referral-btn-clicked"
                    );
                    setActiveForm("ph");
                  }}
                >
                  Photographer
                </button>
                <button
                  className={`geo-btn ${
                    activeForm == "club" ? "active-btn" : ""
                  }`}
                  onClick={() => {
                    Telemetry.track(
                      "internal-referrals:org-gallery-club-referral-btn-clicked"
                    );
                    setActiveForm("club");
                  }}
                >
                  Club
                </button>
              </div>
              <span className="sell-your-photos-sub-header">
                Learn more about how GeoSnapShot takes your photo sales to the
                next level.
              </span>
            </div>
            <div className="geo-modal__body">
              <br />
              <ReferralForm activeForm={activeForm} />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default SellYourPhotos;
